module.exports = __webpack_public_path__ + "img/nacmenu-link.1b130e25.svg";